export enum ViewType {
    LATEST,
    HISTORICAL,
}
